// extracted by mini-css-extract-plugin
export var aboutTitle = "HotelSummary-module--aboutTitle--b942b";
export var accordionDetails = "HotelSummary-module--accordionDetails--42622";
export var addressContainer = "HotelSummary-module--addressContainer--3c029";
export var alt = "HotelSummary-module--alt--17065";
export var amenityItem = "HotelSummary-module--amenityItem--cf75a";
export var amenityList = "HotelSummary-module--amenityList--f42d5";
export var amenitySeparator = "HotelSummary-module--amenitySeparator--00367";
export var carouselContainer = "HotelSummary-module--carouselContainer--d2212";
export var carouselIcon = "HotelSummary-module--carouselIcon--115bc";
export var carouselNextIcon = "HotelSummary-module--carouselNextIcon--1ba3f";
export var carouselPrevIcon = "HotelSummary-module--carouselPrevIcon--72ae7";
export var content = "HotelSummary-module--content--e4223";
export var contentContainer = "HotelSummary-module--contentContainer--3a688";
export var contentInnerWrap = "HotelSummary-module--content-inner-wrap--32119";
export var descContainer = "HotelSummary-module--descContainer--b270c";
export var description = "HotelSummary-module--description--f356b";
export var desktopOnly = "HotelSummary-module--desktopOnly--e0b77";
export var divider = "HotelSummary-module--divider--80adf";
export var horizantalDivider = "HotelSummary-module--horizantalDivider--47f03";
export var horizontal = "HotelSummary-module--horizontal--dd47f";
export var imageWrapper = "HotelSummary-module--image-wrapper--797b5";
export var main = "HotelSummary-module--main--65df5";
export var mobileMargin = "HotelSummary-module--mobileMargin--c1751";
export var mobileOnly = "HotelSummary-module--mobileOnly--9f67c";
export var phoneContainer = "HotelSummary-module--phoneContainer--836d4";
export var plainText = "HotelSummary-module--plainText--51908";
export var swipperContainer = "HotelSummary-module--swipperContainer--98fad";
export var textLeft = "HotelSummary-module--textLeft--3b138";
export var time = "HotelSummary-module--time--8ff1f";
export var title = "HotelSummary-module--title--cdae7";
export var toggleButton = "HotelSummary-module--toggleButton--45347";
export var toggleIcon = "HotelSummary-module--toggleIcon--564ef";
export var visuallyHidden = "HotelSummary-module--visuallyHidden--c3436";